<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-05-16 10:00:40
 * @LastEditors: may.li
 * @LastEditTime: 2023-05-26 08:55:06
-->
<template>
	<div class="page page_settle">
		<div class="adress">
			<div class="info" v-if="selectAddress">
				<div class="user">{{ selectAddress.address_person ? selectAddress.address_person : selectAddress.person }} {{ selectAddress.address_phone ? selectAddress.address_phone : selectAddress.phone }}</div>
				<div class="dizhi" @click="clickAdress">{{ selectAddress.address }}</div>
			</div>
			<div class="info" v-else>
				<div class="user">请选择收货地址</div>
			</div>
			<div class="icon_right" @click="clickAdress"></div>
		</div>
		<!-- 订单 -->
		<div class="order_wrap">
			<div class="order">
				<!-- <div class="order_top">
					<img :src="$publicData.defaultTouxiang" alt="" class="thumb">
					<span class="shop_name">第三方平台</span>
				</div> -->
				<div class="order_list">
					<div class="item clearfix">
						<div class="item_l f-l">
							<img :src="goods.goods_thumb" alt="" class="tu">
						</div>
						<div class="item_r f-l">
							<div class="item_r_t">
								<div class="title slh_s">{{ goods.goods_title }}</div>
								<div class="sku slh_s">数量：{{ goods.num }}</div>
							</div>
							<div class="price"><span class="tag_cash">¥</span>{{ goods.goods_price }}</div>
						</div>
					</div>
				</div>
				<!-- 只支持包邮 -->
				<div class="order_pro youfei">
					<div class="pro_l">邮费</div>
					<div class="pro_r">
						<div class="normal">包邮</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 立即购买 -->
		<div class="bottom tijiao">
			<div class="tijiao_l">共{{ allCount }}件，合计：<span class="price"><span class="tag_cash">¥</span>{{ allPrice }}</span></div>
			<div class="tijiao_r" @click="toPay">立即支付</div>
		</div>
		<van-overlay :show="showLoading">
            <div class="wrapper"><van-loading type="spinner" /></div>
        </van-overlay>
	</div>
</template>
<script>
export default {
	data(){
		return{
			token: null,
			goods: null,
			selectAddress: null,
			allCount: null,
			allPrice: null,
			showLoading: false
		}
	},
	created(){
		this.token = this.$store.getters.token;
		let settle = JSON.parse(this.$store.getters.shop_settle);
		// 当有点选地址时
		this.initData(settle);
	},
	methods: {
		/**
		 * @name: 创建订单
		 * @return {*}
		 * @desc: 
		 */		
		toPay(){
			// 如果没有地址 提示去添加地址
			if( !this.selectAddress || !this.selectAddress.address_id){
				this.$toast('请先选择地址')
				return;
			}
			let gooddata = {
				good_id: this.goods.goods_id,
				company_id: this.goods.company_id,
				num: this.goods.num
			};
			let params = {
				token: this.token,
				address_id: this.selectAddress.address_id,
				gooddata: JSON.stringify(gooddata)
			};
			// console.log('参数',params);
			// return;
			this.showLoading = true;
			this.$api.thirdshop.createorder(params).then(res=>{
				this.showLoading = false;
				if(res.code == 200){
					this.$router.push({
						path: '/shop/pay',
						query: {
							orderId: res.result.pay_order_num,
							price: this.allPrice,
							isPlatprice: 1, // 第三方商城,支持所有支付方式,这里先当b2b处理
							park_point: res.result.park_point, // 所在园区积分
							duihuan_money: res.result.duihuan_money, // 积分兑换比例
							park_uuid: res.result.park_uuid,
							thirdJifenBili: res.result.plat_exchange_points_bili // 第三方积分兑换比例
						}
					})
				}else{
					this.$toast(res.message)
				}
			})
		},
		/**
		 * @name: 拿到存的结算信息
		 * @param {*} settle
		 * @return {*}
		 * @desc: 
		 */			
		initData(settle){
			if(settle){
				this.goods = settle;
				this.allCount = this.goods.num;
				this.allPrice = (this.goods.num * this.goods.goods_price).toFixed(2);
			};
			// 当有点选地址时
			if(this.$store.getters.select_address){
				this.selectAddress = JSON.parse(this.$store.getters.select_address);
			}else{
				// 取默认的
				this.getDefaultaddress();
			}
		},
		/**
		 * @name: 获取默认地址
		 * @return {*}
		 * @desc: 
		 */		
		getDefaultaddress(){
			let params = {
				token: this.token
			};
			this.$api.thirdshop.defaultaddress(params).then(res=>{
				if(res.code == 200){
					let info = res.result;
					info.address_id = info.id;
					this.selectAddress = info;
				}
			})
		},
		/**
		 * @name: 收货地址
		 * @return {*}
		 * @desc: 
		 */		
		clickAdress(){
			 this.$router.push({
				path: '/user/adress',
				query: {
					canSelect: 1,
					addressId: this.selectAddress?this.selectAddress.address_id:''
				}
			})
		}
	},
}
</script>
<style scoped>
.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}
</style>